import { Legend } from './legend';
import { LegendDisplay } from './legendDisplay.interface';

type PageClickFuncType = null | (() => void);
export class PagedLegendDisplay implements LegendDisplay {
  public cssClassName = 'legend-display-paged';

  protected selectedLegend: Legend;

  public displayLegend(
    legends: Array<Legend>,
    setContentFunction: (contentElement: HTMLElement, headerElements?: Array<HTMLElement>) => void,
    index: null | number = null,
  ): void {
    if (index == null) {
      index = legends.findIndex((legend: Legend) => legend === this.selectedLegend);
      // previously selected legend is no longer available.
      if (index < 0) {
        index = 0;
      }
    }
    const selectedIndex = index;
    this.selectedLegend = legends[index];

    const changeDisplayFunc = (newIndex: number) => {
      this.displayLegend(legends, setContentFunction, newIndex);
    };

    setContentFunction(
      this.getLegendContent(this.selectedLegend),
      this.getLegendHeader(
        this.selectedLegend,
        (selectedIndex > 0) ? () => changeDisplayFunc(selectedIndex - 1) : null,
        ((selectedIndex + 1) < legends.length) ? () => changeDisplayFunc(selectedIndex + 1) : null,
      ),

    );
  }

  protected getLegendHeader(
    legend: Legend,
    previousClickFunc: PageClickFuncType = null,
    nextClickFunc: PageClickFuncType = null,
  ): Array<HTMLElement> {

    const content = new Array<HTMLElement>();

    const navDiv = document.createElement('div');
    navDiv.classList.add('legend-nav');

    // title
    if (legend != null) {
      const titleDisplay = legend.createDisplayTitle();
      titleDisplay.classList.add('legend-title');
      content.push(titleDisplay);
    }

    const paginationDiv = this.createPagination(
      previousClickFunc,
      nextClickFunc,
    );
    content.push(paginationDiv);

    return content;
  }

  protected getLegendContent(
    legend: Legend,
  ): HTMLElement {

    const contentDiv = document.createElement('div');

    if (legend != null) {
      const legendDetailsDiv = document.createElement('div');
      legendDetailsDiv.classList.add('legend-details');
      legendDetailsDiv.appendChild(legend.createDisplayContent());
      contentDiv.appendChild(legendDetailsDiv);
    }

    return contentDiv;
  }

  protected createPagination(
    previousClickFunc: null | (() => void),
    nextClickFunc: null | (() => void),
  ): HTMLElement {
    const headerDiv = document.createElement('div');
    headerDiv.classList.add('legend-pagination');

    // Show pagination if there is more than one legend
    if ((null != previousClickFunc) || (null != nextClickFunc)) {

      // previous butt
      const previousButt = this.createButton(
        '<i class="fas fa-caret-left"></i>',
        previousClickFunc,
        ['pagination-prev'],
      );
      headerDiv.appendChild(previousButt);
      // next butt
      const nextButt = this.createButton(
        '<i class="fas fa-caret-right"></i>',
        nextClickFunc,
        ['pagination-next'],
      );
      headerDiv.appendChild(nextButt);
    }
    return headerDiv;
  }

  protected createButton(
    content: string,
    clickFunc: PageClickFuncType,
    classes = new Array<string>(),
  ): HTMLElement {
    const butt = document.createElement('button');
    butt.setAttribute('type', 'button');
    butt.classList.add('btn');
    butt.classList.add('btn-xs');
    classes.forEach((classy: string) => {
      butt.classList.add(classy);
    });
    butt.addEventListener('click', (event: Event) => {
      event.stopPropagation();
      if (clickFunc != null) {
        clickFunc();
      }
    });

    if (clickFunc == null) {
      butt.classList.add('disabled');
    }
    butt.innerHTML = content;
    return butt;
  }

}
